export const init = () => {
    const videos = document.querySelectorAll('video[autoplay]');
    
    videos.forEach(video => {
        // Ensure muted is true for autoplay to work in most browsers
        video.muted = true;
        
        // Ensure playsinline is set for mobile devices
        if (!video.hasAttribute('playsinline')) {
            video.setAttribute('playsinline', '');
        }

        // Try to play the video
        const playPromise = video.play();
        
        if (playPromise !== undefined) {
            playPromise.then(() => {
                // Video is playing
            }).catch(error => {
                // Autoplay was prevented by the browser. 
                // This can happen if the user hasn't interacted with the page yet.
                // console.warn("Video autoplay was prevented:", error);
                
                // Optional: Attempt to play on first user interaction if it failed
                const playOnInteraction = () => {
                    video.play();
                    window.removeEventListener('click', playOnInteraction);
                    window.removeEventListener('keydown', playOnInteraction);
                    window.removeEventListener('touchstart', playOnInteraction);
                };
                
                window.addEventListener('click', playOnInteraction);
                window.addEventListener('keydown', playOnInteraction);
                window.addEventListener('touchstart', playOnInteraction);
            });
        }
    });
};
